import $http from '@Config/axios';

const buildTabela = tabela => ({
  id: tabela.id,
  text: `${tabela.nome} ${tabela.versao ? ` - ${tabela.versao} ` : ''}`,
  nome: tabela.nome,
  versao: tabela.versao,
  value: tabela.id + 2,
  instituicao_id: tabela.instituicao_id
});

export default {
  index(params) {
    return new Promise((resolve, reject) => {
      $http.post('tabela/dietas', params)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  },
  indexTabelas(params) {
    return new Promise((resolve, reject) => {
      $http.post('tabela/dietas/tabelas', params)
        .then(response => resolve(response.map(item => buildTabela(item))))
        .catch(response => reject(response));
    });
  },
  show(id) {
    return new Promise((resolve, reject) => {
      $http.get(`tabela/dietas/${id}`)
        .then(response => resolve(response))
        .catch(response => reject(response));
    });
  }
};
